import { useEffect, useState } from "react";

import { Input, Typography } from "antd";
import PropTypes from "prop-types";
import WarningOutlined from "@ant-design/icons/WarningOutlined";
import { useController } from "react-hook-form";

import FieldError from "./FieldError.jsx";
import EyeIcon from "@/assets/icons/eye-icon.svg?react";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer.js";

const { Text } = Typography;

const InputField = ({
  name,
  control,
  placeholder = null,
  htmlType = "text",
  disabled = false,
  type = "input",
  rows = 4,
  isEdit = true,
  ...props
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  const [showPassword, setShowPassword] = useState(false);

  /**
   * Prepends a plus sign (+) to an input of type phone whose value does not have it at the start.
   */
  useEffect(() => {
    if (htmlType === "phone") {
      let value = field.value;
      if (!value) return;
      value = value.replace(/[^\d+\s]/g, "");
      if (value === "") {
        field.onChange("+");
      } else if (!value.startsWith("+")) {
        field.onChange("+" + value);
      } else {
        field.onChange(value);
      }
    }
  }, [field.value]);

  const prefix = error ? <WarningOutlined type="smile" /> : <span />;

  const changeShowPassword = () => setShowPassword((oldVal) => !oldVal);
  const passwordIcon = showPassword ? (
    <span onClick={changeShowPassword}>
      <BaseSvgRenderer
        component={EyeIcon}
        style={{ transform: "rotate(180deg)" }}
      />
    </span>
  ) : (
    <span onClick={changeShowPassword}>
      <BaseSvgRenderer component={EyeIcon} />
    </span>
  );
  const suffix =
    htmlType === "password" || showPassword ? passwordIcon : <span />;

  const Component = type === "textarea" ? Input.TextArea : Input;

  return (
    <div>
      {isEdit ? (
        <Component
          prefix={prefix}
          suffix={suffix}
          status={error && "error"}
          {...(type === "textarea" ? { rows } : {})}
          placeholder={placeholder}
          type={showPassword ? "text" : htmlType}
          style={{
            borderRadius: 0,
            height: type === "textarea" ? null : "35px",
          }}
          {...field}
          disabled={disabled}
          {...props}
          onKeyPress={(event) => {
            if (htmlType === "number") {
              const invalidChars = ["e", "E", ".", "+", "-"];
              if (invalidChars.includes(event.key)) {
                event.preventDefault();
              }
            }
          }}
        />
      ) : (
        <Text>{field.value}</Text>
      )}
      {error && <FieldError errors={error} />}
    </div>
  );
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  htmlType: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  rows: PropTypes.number,
  isEdit: PropTypes.bool,
};

export default InputField;
